import React, { useState, useLayoutEffect, useEffect } from 'react';
import Header from 'components/organisms/ChatHeader';
import Middle from 'components/organisms/ChatMiddle';
import Footer from 'components/organisms/ChatFooter';
import ChatModal from 'components/organisms/ChatModal';
import Guide from 'components/pages/Guide';
import moment from 'moment';

const domainUrlParam = process.env.REACT_APP_DOMAIN_URL;

const ChatTemplate = () => {

  return (
    <div className="frame_set" style={{ zIndex: 9999, width: '100%', height: '100vh', position: 'relative' }}>
      {localStorage.getItem('yongin_chat_guide') === 'false' ? <Guide /> : ''}
      <Header domainUrlParam={domainUrlParam} />
      <Middle />
      <Footer domainUrlParam={domainUrlParam} />
      <ChatModal />
    </div>
  );
};

export default ChatTemplate;
